import { useEffect, useRef } from 'react';

import { DEFAULT_FINGER_PRINT_VALUE } from '../constants/fingerPrint';
import { useFingerprint } from '../store/hooks/users';

export const useOnFingerprintCreate = (handler: (fp: string) => void) => {
  const fingerprint = useFingerprint();
  const handledRef = useRef(false);

  useEffect(() => {
    if (!handledRef.current && fingerprint !== DEFAULT_FINGER_PRINT_VALUE) {
      handledRef.current = true;
      handler(fingerprint);
    }
  }, [fingerprint, handler]);
};
